import React from 'react';
import { Droplets, DollarSign, TrendingUp } from 'lucide-react';
import { fmt, fmtUSD } from './formatters';  // Changé

const TodayStats = ({ stats }) => {
  if (!stats) return null;
  
  const items = [
    { label: "Gallons dispensed today", value: fmt(stats.total_gallons, 1), icon: <Droplets size={18} />, color: 'text-blue-400' },
    { label: "Revenue today", value: fmtUSD(stats.total_revenue), icon: <DollarSign size={18} />, color: 'text-green-400' },
    { label: "Transactions today", value: fmt(stats.transaction_count), icon: <TrendingUp size={18} />, color: 'text-orange-400' },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {items.map(({ label, value, icon, color }) => (
        <div key={label} className="bg-gray-800/50 rounded-xl border border-gray-700 p-4">
          <div className={`${color} mb-2`}>{icon}</div>
          <p className="text-2xl font-bold text-white">{value}</p>
          <p className="text-gray-400 text-xs mt-1">{label}</p>
        </div>
      ))}
    </div>
  );
};

export default TodayStats;